<script>
import { mapState } from 'vuex'

const STORE_NAME_KEY = '&lt;Nombre_Aliado&gt;'

export default {
  name: 'AlternativeArticle',
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    buildBodyInformation: function () {
      const body = this.componentData.body ? this.componentData.body : ''
      return body.replace(STORE_NAME_KEY, this.orderData.store.name)
    },
    ...mapState('widgets', {
      orderData: state => state.data.SharedData.orderData,
    }),
  },
  methods: {},
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.container__header">
      <v-icon
        :class="$style.container__primary"
        large
      >info</v-icon>
      <h3>{{ componentData.title }}</h3>
    </div>
    <div :class="$style.container__content">
      <p v-html="buildBodyInformation" />
    </div>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  padding: 1.5rem;

  &__header {
    h3 {
      @extend %typography-large;

      font-weight: bold;
      color: $darker-gray;
    }
  }

  &__primary {
    color: $primary-green;
  }

  &__content {
    @extend %typography-medium;

    padding-right: 1.5rem;
    padding-left: 1.5rem;
    margin-top: 1rem;
    text-align: center;
  }
}
</style>
